const getDefaultState = () => {
  return {
    associatedEmail: '',
  };
};

const onboarding = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    initialize (state) {
      Object.assign(state, getDefaultState());
    },
  },
};

export default onboarding;
